import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  ENVELOPE,
  LayoutColumnsDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { getEditorState } from '~/shell/Store';

export const SocialMedia5: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;
  let isEmail = false;
  (sequence.items ?? []).forEach(item => {
    if (item.__typename === 'Email') {
      isEmail = true;
    }
  });
  const contentEditable = getEditorState().contentEditable;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Email':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            overflow: 'visible',
            height: { _: 'auto', lg: '100%' }
          },
          items: [
            {
              type: ENVELOPE,
              id: item.id,
              values: {
                from: 'username@email.com',
                subject: 'Marco’s medical record',
                logo: sequence.personalization
                  ? true
                  : item?.pictures
                  ? item.pictures[0].mediaUrl
                  : null
              },
              items: [
                {
                  type: TEXT,
                  id: item.id + '_body',
                  items: [],
                  values: {
                    value: item.body?.replace(
                      '[user]',
                      item.title ? item.title : ''
                    ),
                    variant: 'text'
                  }
                }
              ]
            }
          ]
        } as LayoutListDefinition);
        break;

      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            height: { _: 'auto', lg: '100%' },
            padded: true
          },
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: { align: 'left' },
              items: [
                ...((!isEmail || !contentEditable) &&
                item.items &&
                item.items.length
                  ? [
                      {
                        type: TEXT,
                        id: `${item.id}_subtitle`,
                        items: [],
                        values: {
                          value: item.subtitle || 'QUIZ',
                          variant: 'sub_heading',
                          icon: item.icon
                        }
                      }
                    ]
                  : []),

                {
                  type: TEXT,
                  id: item.id + '_title',
                  items: [],
                  values: {
                    value: item.title,
                    variant: 'heading1'
                  }
                },
                {
                  type: TEXT,
                  id: item.id + '_body',
                  items: [],
                  values: {
                    value: item.body
                  }
                },
                {
                  type: QUIZ_CHOICE,
                  id: '1',
                  values: {
                    variant: item.items && item.items.length > 2 ? 'list' : '',
                    title: item?.title?.includes('?')
                      ? item.title
                      : item?.body?.includes('?')
                      ? item.body
                      : '',
                    length: item?.items?.length,
                    multiSelect: item?.items?.filter(
                      item => item.correct === true
                    ).length
                  },
                  items: AnswerButtonHelper(
                    item.id,
                    item.items,
                    undefined,
                    item.llamaSurvey,
                    item.title || ''
                  )
                }
              ]
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
